import React from "react";
import { StatusChip } from "../../../../../component/listing";
import { tokens } from "../../../../../theme";

/**
 * An employee's own expense claims, as columns.
 *
 * The overview and the full list show the same four things about a claim, and
 * were carrying two copies of them — which is how one of them ends up saying
 * "Date" while the other says "Submitted". Declared once so both read the same.
 */
export const STATUS_TONE = { pending: "warning", approved: "success", rejected: "danger", reimbursed: "info" };

export const expenseColumns = (money) => [
  {
    key: "category",
    label: "Category",
    cellSx: { fontWeight: 600 },
    render: (r) => r?.policyCateogary?.name || "—",
  },
  {
    key: "date",
    label: "Date",
    cellSx: { color: tokens.textMuted },
    render: (r) => new Date(r?.createdDate || r?.createdAt).toLocaleDateString("en-GB"),
  },
  { key: "amount", label: "Amount", align: "right", render: (r) => money(r?.amount) },
  {
    key: "status",
    label: "Status",
    render: (r) => <StatusChip label={r?.status} tone={STATUS_TONE[r?.status]} />,
  },
];
